import React from 'react';
import styled from 'styled-components';
import Typography from '../../Typography';
import Icon from '../../Icon';
var DialogTitleContent = styled.div.attrs({
  className: 'bbui-dialog-title-content'
}).withConfig({
  displayName: "DialogTitle__DialogTitleContent",
  componentId: "sc-1h4d0cx-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;flex:1;min-height:48px;"]);
var DialogTitleHeader = styled(Typography.H2).attrs({
  className: 'bbui-dialog-title-header'
}).withConfig({
  displayName: "DialogTitle__DialogTitleHeader",
  componentId: "sc-1h4d0cx-1"
})(["flex:8;line-height:1.15;"]);
var DialogTitleCloseIcon = styled(Icon).attrs({
  className: 'bbui-dialog-title-close-icon',
  name: 'x'
}).withConfig({
  displayName: "DialogTitle__DialogTitleCloseIcon",
  componentId: "sc-1h4d0cx-2"
})(["color:", ";cursor:pointer;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.backgroundShades.strong;
});
/**
 * Component for rendering the title of a dialog. Children are placed inside a nested `<H1 />`.
 */

export var DialogTitle = function DialogTitle(_ref2) {
  var children = _ref2.children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      onClose = _ref2.onClose,
      _ref2$showDelimiter = _ref2.showDelimiter,
      showDelimiter = _ref2$showDelimiter === void 0 ? true : _ref2$showDelimiter;
  return React.createElement("div", {
    className: "bbui-dialog-title ".concat(className)
  }, React.createElement(DialogTitleContent, null, React.createElement(DialogTitleHeader, null, children), onClose && React.createElement(DialogTitleCloseIcon, {
    onClick: onClose
  })), showDelimiter && React.createElement("hr", {
    className: "bbui-dialog-title-delimiter"
  }));
};
/**
 * @visibleName Dialog.Title
 */

export default styled(DialogTitle).withConfig({
  displayName: "DialogTitle",
  componentId: "sc-1h4d0cx-3"
})(["padding:8px 16px 0 16px;.bbui-dialog-title-delimiter{border-style:solid;border-color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.backgroundShades.strong;
});